/**
 * Users API setup for Falcon using @roselabs-io/saas-shell
 *
 * This configures the UsersApi for Falcon's specific needs.
 */

import { createUsersApi } from '@roselabs-io/saas-shell'
import type {
  UsersApi,
  UserProfile,
  TwoFactorSetupResponse,
  ApiKey,
  ApiKeyListResponse,
} from '@roselabs-io/saas-shell'
import apiClient, { authApiClient } from '../api/client'

// Create users API configured for Falcon
export const usersApi = createUsersApi({
  authApiClient,
  productApiClient: apiClient,
})

// Re-export types from saas-shell for convenience
export type { UsersApi, UserProfile, TwoFactorSetupResponse, ApiKey, ApiKeyListResponse }
